export const sortByDate = (articles) => {
	articles.sort(({ created_at: a } = {}, { created_at: b } = {}) => new Date(b) - new Date(a));
	return articles;
};
